import axios from 'axios';
import { useQuery, useMutation, useQueryClient } from 'react-query';


const API_BASE_URL = '/api';

export function useFetchTrackReportDetails(token) {
    return useQuery(['reportTrackDetails', token], async ({ queryKey }) => {
        const [, token] = queryKey;
        const response = await axios.post(
            '/api/track/report/overview', {},
            {
                headers: {
                    Authorization: `Bearer ${token}`
                },
            }
        );
        return response.data;
    }, {
        enabled: !!token,
        staleTime: 2 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}

export function useFetchClientInvoices(token) {
    return useQuery(['clientInvoices', token], async ({ queryKey }) => {
        const [, token] = queryKey;

        const response = await axios.get(
            `/api/clients/invoices`,
            {
                params: {
                    page: 1,
                    limit: 10000, // Fetch all invoices for reporting (or use a very high limit)
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        // Handle both old format (array) and new format (object with data property)
        const responseData = response.data;
        if (Array.isArray(responseData)) {
            return responseData;
        }
        // If it's the new paginated format, return the data array
        return responseData?.data || [];

    }, {
        enabled: !!token,
        staleTime: 2 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}

export function useFetchExpenses(token) {
    return useQuery(['allExpenses', token], async ({ queryKey }) => {
        const [, token] = queryKey;

        const response = await axios.get(
            `/api/expenses`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;

    }, {
        enabled: !!token,
        staleTime: 2 * 60 * 1000,
        cacheTime: 10 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}

export function useFetchSprints(token) {
    return useQuery(['allSprints', token], async ({ queryKey }) => {
        const [, token] = queryKey;

        const response = await axios.get(
            `/api/sprint/report/overview`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;

    }, {
        enabled: !!token,
        staleTime: 5 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}

export function useFetchProjectCosts(token) {
    return useQuery(['projectCosts', token], async ({ queryKey }) => {
        const [, token] = queryKey;

        const response = await axios.get(
            `/api/user/project/cost/report`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;

    }, {
        enabled: !!token,
        staleTime: 5 * 60 * 1000,
        cacheTime: 15 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}
